const routes = [
  {
    path: '/',
    component: () => import('@/pages/Layout'),
    children: [
      { path: '', component: () => import('@/pages/Home') },
      // 帮助附件
      { path: 'help/att', name: 'Help', meta: {keepAlive: true, request: true}, component: () => import('@/pages/help/Att') },
      // 用户管理
      { path: 'user/to', name: 'User', meta: {keepAlive: true, request: true}, component: () => import('@/pages/sys/User') },
      { path: 'user/add', component: () => import('@/pages/sys/actions/UserAdd') },
      { path: 'user/info/:id', props: true, component: () => import('@/pages/sys/actions/UserInfo') },
      // 角色管理
      { path: 'role/to', name: 'Role', meta: {keepAlive: true, request: true}, component: () => import('@/pages/sys/Role') },
      { path: 'role/add', component: () => import('@/pages/sys/actions/RoleAdd') },
      { path: 'role/info/:id', props: true, component: () => import('@/pages/sys/actions/RoleInfo') },
      // 工作日设置
      { path: 'dimdate/to', component: () => import('@/pages/sys/WorkDay') },
      // 数据库备份
      { path: 'backdb/to', component: () => import('@/pages/sys/BackDB') },
      // 日志管理
      { path: 'loginLog/to', name: 'LogLogin', meta: {keepAlive: true}, component: () => import('@/pages/sys/LogLogin') },
      { path: 'userLog/to', name: 'LogUser', meta: {keepAlive: true}, component: () => import('@/pages/sys/LogUser') },
      // 机构管理
      { path: 'org/to', name: 'Org', meta: {keepAlive: true, request: true}, component: () => import('@/pages/org/Org') },
      { path: 'org/info/:id', name: 'OrgInfo', meta: {keepAlive: true}, props: true, component: () => import('@/pages/org/actions/OrgInfo') },
      { path: 'org/add', name: 'OrgAdd', meta: {keepAlive: true}, props: true, component: () => import('@/pages/org/actions/OrgAdd') },
      // 员工管理
      { path: 'emp/to', name: 'Emp', meta: {keepAlive: true, request: true}, component: () => import('@/pages/org/Emp') },
      { path: 'emp/add', name: 'EmpAdd', props: true, component: () => import('@/pages/org/actions/EmpAdd') },
      { path: 'emp/edit/:id', name: 'EmpEdit', props: true, component: () => import('@/pages/org/actions/EmpEdit') },
      { path: 'emp/info/:id', props: true, component: () => import('@/pages/org/actions/EmpInfo') },
      // 合作管理
      { path: 'partner/to', name: 'Coop', meta: {keepAlive: true, request: true}, component: () => import('@/pages/partners/Coop') },
      { path: 'coop/add', name: 'CoopAdd', meta: {keepAlive: true}, props: true, component: () => import('@/pages/partners/actions/CoopAdd') },
      { path: 'coop/info/:id', name: 'CoopInfo', meta: {keepAlive: true, request: true}, props: true, component: () => import('@/pages/partners/actions/CoopInfo') },
      { path: 'coop/edit/:id', name: 'CoopEdit', meta: {keepAlive: true}, props: true, component: () => import('@/pages/partners/actions/CoopEdit') },
      // 物料管理
      // 零件信息
      { path: 'part/to', name: 'Part', meta: {keepAlive: true, request: true}, component: () => import('@/pages/matter/Part') },
      { path: 'part/add', name: 'PartAdd', meta: {keepAlive: true}, props: true, component: () => import('@/pages/matter/actions/PartAdd') },
      { path: 'part/info/:partID/:partNo', props: true, name: 'PartInfo', meta: {keepAlive: true, request: true}, component: () => import('@/pages/matter/actions/PartInfo') },
      { path: 'part/edit/:partID/:partNo', name: 'PartEdit', meta: {keepAlive: true}, props: true, component: () => import('@/pages/matter/actions/PartEdit') },
      // BOM信息
      { path: 'bom/to', name: 'Bom', meta: {keepAlive: true, request: true}, component: () => import('@/pages/matter/Bom') },
      { path: 'bom/add', name: 'BomAdd', meta: {keepAlive: true}, props: true, component: () => import('@/pages/matter/actions/BomAdd') },
      { path: 'bom/info/:id/:bomNo', props: true, component: () => import('@/pages/matter/actions/BomInfo') },
      { path: 'bom/edit/:id', name: 'BomEdit', meta: {keepAlive: true}, props: true, component: () => import('@/pages/matter/actions/BomEdit') },
      // 客户管理
      { path: 'cust/to', name: 'Cust', meta: {keepAlive: true, request: true}, component: () => import('@/pages/sales/cust/Cust') },
      { path: 'cust/add', name: 'CustAdd', meta: {keepAlive: true}, component: () => import('@/pages/sales/cust/actions/CustAdd') },
      { path: 'cust/info/:id', name: 'CustInfo', props: true, meta: {keepAlive: true}, component: () => import('@/pages/sales/cust/actions/CustInfo') },
      { path: 'cust/edit/:id', name: 'CustEdit', meta: {keepAlive: true}, props: true, component: () => import('@/pages/sales/cust/actions/CustEdit') },
      // 销售管理
      { path: 'order/to', name: 'Order', meta: {keepAlive: true, request: true}, component: () => import('@/pages/sales/order/Order') },
      { path: 'order/add/:id', name: 'OrderAdd', meta: {keepAlive: true}, props: true, component: () => import('@/pages/sales/order/actions/OrderEdit') },
      { path: 'order/edit/:id/:tbuFlag', props: true, component: () => import('@/pages/sales/order/actions/OrderEdit') },
      { path: 'order/info/:id/:canEdit', name: 'SaleOrderInfo', meta: {id: '103030203', request: true, keepAlive: true}, props: true, component: () => import('@/pages/sales/order/actions/OrderInfo') },
      { path: 'order/info/:id', props: true, component: () => import('@/pages/sales/order/actions/OrderInfo') },
      // 销售查询
      { path: 'salesorder/to', name: 'SalesOrder', meta: {id: '103040100', keepAlive: true, request: true}, component: () => import('@/pages/salesSearch/SalesOrder') },
      { path: 'salesout/to', name: 'SalesOut', meta: {id: '103040200', keepAlive: true, request: true}, component: () => import('@/pages/salesSearch/SalesOut') },
      { path: 'costdiff/to', name: 'CostDiff', meta: {id: '103040300', keepAlive: true, request: true}, component: () => import('@/pages/salesSearch/CostDiff') },
      { path: 'salespart/to', name: 'SalesPart', meta: {id: '103040400', keepAlive: true, request: true}, component: () => import('@/pages/salesSearch/SalesPart') },
      { path: 'costdetail/to', name: 'CostDetail', meta: {id: '103040500', keepAlive: true, request: true}, component: () => import('@/pages/salesSearch/CostDetail') },
      {
        path: 'salestotal/to',
        name: 'SalesTotal',
        meta: {keepAlive: true, request: true},
        component: async () => {
          let cpn = await import('@/pages/salesSearch/SalesTotal')
          cpn.default.name = 'SalesTotal'
          return cpn
        }
      },
      {
        path: 'salestotal/to2/:flag',
        props: true,
        name: 'SalesTotal2',
        meta: {keepAlive: true, request: true},
        component: async () => {
          let cpn = await import('@/pages/salesSearch/SalesTotal')
          cpn.default.name = 'SalesTotal2'
          return cpn
        }
      },
      // 采购管理
      { path: 'supplier/to', name: 'Supplier', meta: {keepAlive: true, request: true}, component: () => import('@/pages/purchaseManager/Supplier') },
      { path: 'supplier/add', name: 'SupplierAdd', meta: {keepAlive: true}, component: () => import('@/pages/purchaseManager/actions/SupplierAdd') },
      { path: 'supplier/edit/:id', name: 'SupplierEdit', meta: {keepAlive: true}, props: true, component: () => import('@/pages/purchaseManager/actions/SupplierEdit') },
      { path: 'supplier/info/:id', props: true, component: () => import('@/pages/purchaseManager/actions/SupplierInfo') },
      { path: 'mrp/to', name: 'MRP', meta: {id: '103030215', keepAlive: true, request: true}, component: () => import('@/pages/purchaseManager/MRP') },
      { path: 'mrpv2/to', name: 'MRPv2', meta: {id: '103030219', keepAlive: true, request: true}, component: () => import('@/pages/purchaseManager/MRPv2') },
      { path: 'purchaseorder/to', name: 'PurchaseOrder', meta: {keepAlive: true, request: true}, component: () => import('@/pages/purchaseManager/Order') },
      { path: 'purchaseorder/add/:id', name: 'PurchaseOrderAdd', meta: {keepAlive: true}, props: true, component: () => import('@/pages/purchaseManager/actions/OrderEdit') },
      { path: 'purchaseorder/edit/:id/:tbuFlag', props: true, component: () => import('@/pages/purchaseManager/actions/OrderEdit') },
      { path: 'purchaseorder/info/:id', props: true, name: 'PurchaseMagOrderInfo', meta: {keepAlive: true, request: true}, component: () => import('@/pages/purchaseManager/actions/OrderInfo') },
      // 采购
      { path: 'costorder/to', name: 'CostOrder', meta: {id: '103060100', keepAlive: true, request: true}, component: () => import('@/pages/purchase/CostOrder') },
      { path: 'costout/to', name: 'CostOut', meta: {id: '103060200', keepAlive: true, request: true}, component: () => import('@/pages/purchase/CostOut') },
      { path: 'costpart/to', name: 'CostPart', meta: {id: '103060300', keepAlive: true, request: true}, component: () => import('@/pages/purchase/CostPart') },
      { path: 'aulsumsupplier/to', name: 'AulSumBySupplier', meta: {id: '103050311', keepAlive: true, request: true}, component: () => import('@/pages/purchase/AulSumBySupplier') },
      { path: 'costtotal/to', name: 'CostTotal', meta: {id: '103060400', keepAlive: true, request: true}, component: () => import('@/pages/purchase/CostTotal') },
      { path: 'cost/edit/:id', component: () => import('@/pages/purchase/actions/CostEdit') },
      { path: 'instock/to', name: 'InStock', meta: {id: '103060500', keepAlive: true, request: true}, component: () => import('@/pages/purchase/InStock') },
      { path: 'charge/to', name: 'Charge', meta: {id: '103060600', keepAlive: true, request: true}, component: () => import('@/pages/purchase/Charge') },
      // 仓库管理
      { path: 'stock/to', name: 'Stock', meta: {id: 'M103070100', keepAlive: true, request: true}, component: () => import('@/pages/stock/Stock') },
      { path: 'stocksearch/to', name: 'StockSearch', meta: {keepAlive: true, request: true}, component: () => import('@/pages/stock/StockSearch') },
      {
        path: 'stock/add/:id',
        name: 'StockAdd',
        meta: {keepAlive: true},
        props: true,
        component: async () => {
          let cpn = await import('@/pages/stock/actions/StockEdit')
          cpn.default.name = 'StockAdd'
          return cpn
        }
      },
      {
        path: 'stock/edit/:id',
        name: 'StockEdit',
        meta: {keepAlive: true},
        props: true,
        component: async () => {
          let cpn = await import('@/pages/stock/actions/StockEdit')
          cpn.default.name = 'StockEdit'
          return cpn
        }
      },
      { path: 'stock/info/:id', props: true, component: () => import('@/pages/stock/actions/StockInfo') },
      { path: 'loan/to', name: 'LoanReturn', meta: {keepAlive: true, request: true}, component: () => import('@/pages/stock/LoanReturn') },
      // 生产计划
      { path: 'prod/to', name: 'Prod', meta: {keepAlive: true, request: true}, component: () => import('@/pages/prod/Prod') },
      {
        path: 'prod/add/:id',
        name: 'ProdAdd',
        meta: {keepAlive: true},
        props: true,
        component: async () => {
          let cpn = await import('@/pages/prod/actions/ProdEdit')
          cpn.default.name = 'ProdAdd'
          return cpn
        }
      },
      {
        path: 'prod/edit/:id',
        name: 'ProdEdit',
        meta: {keepAlive: true},
        props: true,
        component: async () => {
          let cpn = await import('@/pages/prod/actions/ProdEdit')
          cpn.default.name = 'ProdEdit'
          return cpn
        }
      },
      { path: 'prod/info/:id', props: true, component: () => import('@/pages/prod/actions/ProdInfo') },
      { path: 'toprod/to', name: 'ToProd', meta: {keepAlive: true, request: true}, component: () => import('@/pages/prod/ToProd') },
      { path: 'proj/to', name: 'Proj', meta: {keepAlive: true, request: true}, component: () => import('@/pages/prod/Proj') },
      {
        path: 'proj/add/:id',
        name: 'ProjAdd',
        meta: {keepAlive: true},
        props: true,
        component: async () => {
          let cpn = await import('@/pages/prod/actions/ProjEdit')
          cpn.default.name = 'ProjAdd'
          return cpn
        }
      },
      {
        path: 'proj/edit/:id',
        name: 'ProjEdit',
        meta: {keepAlive: true},
        props: true,
        component: async () => {
          let cpn = await import('@/pages/prod/actions/ProjEdit')
          cpn.default.name = 'ProjEdit'
          return cpn
        }
      },
      { path: 'proj/info/:id', props: true, component: () => import('@/pages/prod/actions/ProjInfo') },
      // 财务管理
      { path: 'crmt/to', name: 'Crmt', meta: {keepAlive: true, request: true}, component: () => import('@/pages/finance/Crmt') },
      { path: 'crmt/add', name: 'CrmtAdd', meta: {keepAlive: true}, component: () => import('@/pages/finance/actions/CrmtAdd') },
      { path: 'crmt/edit/:id', name: 'CrmtEdit', meta: {keepAlive: true}, props: true, component: () => import('@/pages/finance/actions/CrmtEdit') },
      { path: 'cost/to', name: 'Cost', meta: {keepAlive: true, request: true}, component: () => import('@/pages/finance/Cost') },
      {
        path: 'cost/add/:id',
        name: 'CostAdd',
        meta: {keepAlive: true},
        props: true,
        component: async () => {
          let cpn = await import('@/pages/finance/actions/CostEdit')
          cpn.default.name = 'CostAdd'
          return cpn
        }
      },
      {
        path: 'fcost/edit/:id',
        name: 'CostEdit',
        meta: {keepAlive: true},
        props: true,
        component: async () => {
          let cpn = await import('@/pages/finance/actions/CostEdit')
          cpn.default.name = 'CostEdit'
          return cpn
        }
      },
      { path: 'cost/info/:id', props: true, component: () => import('@/pages/finance/actions/CostInfo') },
      { path: 'ar/to', name: 'Ar', meta: {id: '103090300', keepAlive: true, request: true}, component: () => import('@/pages/finance/Ar') },
      { path: 'ar/add', component: () => import('@/pages/finance/actions/ArAdd') },
      { path: 'apay/to', name: 'APay', meta: {id: '103090400', keepAlive: true, request: true}, component: () => import('@/pages/finance/APay') },
      { path: 'apay/add', component: () => import('@/pages/finance/actions/ApayAdd') },
      { path: 'receive/to', name: 'InvoiceReceive', meta: {id: '103090600', keepAlive: true, request: true}, component: () => import('@/pages/finance/InvoiceReceive') },
      { path: 'popaydetail/to', name: 'PoPayDetail', meta: {id: '103090800', keepAlive: true, request: true}, component: () => import('@/pages/finance/PoPayDetail') },
      { path: 'sopaydetail/to', name: 'SoPayDetail', meta: {keepAlive: true}, component: () => import('@/pages/finance/SoPayDetail') },
      { path: 'receive/edit/:id', props: true, component: () => import('@/pages/finance/actions/receiveEdit') },
      { path: 'toInvoice/to', name: 'ToInvoice', meta: {id: '103090500', keepAlive: true, request: true}, component: () => import('@/pages/finance/ToInvoice') },
      { path: 'invoice/edit/:id', props: true, component: () => import('@/pages/finance/actions/invoiceEdit') }
    ]
  },
  { path: '/login', component: () => import('@/pages/Login') },
  { path: '/modPW', component: () => import('@/pages/ModPW') },
  { path: '/forgetPwd', component: () => import('@/pages/forgetPwd') }

]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js